import { Component } from '@angular/core';
import { ModalController, NavController, NavParams} from 'ionic-angular';
import {FormBuilder, FormGroup} from "@angular/forms";
import {SuperTabsController} from "../../components/ionic2-super-tabs/src";
import {XpReportService} from "../../services/xp-report.service";
import {InfoModalPage} from "../info-modal/info-modal";

@Component({
  selector: 'page-xp-report-workorder',
  templateUrl: 'xp-report-workorder.html',
})
export class XpReportWorkorderPage {

  data: any;
  reportForm: FormGroup;
  showFooter = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    public superTabsCtrl: SuperTabsController,
    public reportService: XpReportService,
    public modalCtrl: ModalController
  ) {
    this.initForm();
  }

  initForm(){
    this.data = this.reportService.getData();
    if(!this.data.customers) this.data.customers = {};
    let has_data = true;
    this.reportForm = this.formBuilder.group({
      workorder_nr: [(has_data ? this.data.workorder_nr : '')],
      reference_nr: [(has_data ? this.data.reference_nr : '')]
    });
  }

  ionViewDidEnter() {
    console.log('ReportWorkorderPage: ionViewDidEnter');
    this.initForm();
    // iOS footer display fix
    this.showFooter = false;
    setTimeout(() => {
      this.showFooter = true;
    }, 100);
  }

  ionViewDidLeave(){
    console.log('ReportWorkorderPage: ionViewDidLeave');
    this.save();
  }

  save(){
    this.reportForm.markAsTouched();
    if(this.reportForm.valid){
      this.superTabsCtrl.setColor('reportWorkorderPage', 'tab_ok', 'mainTabs');
      this.data._valid.reportWorkorderPage = 1;
    } else {
      this.superTabsCtrl.setColor('reportWorkorderPage', 'tab_error', 'mainTabs');
      this.data._valid.reportWorkorderPage = -1;
    }
    // Assign to data
    Object.assign(this.data, this.reportForm.value);
    this.reportService.setData(this.data);
  }

  confirm(){
    this.save();
    this.reportService.save().then(() => {
      this.superTabsCtrl.slideTo('reportSelectUnitPage', 'mainTabs');
    });
  }

  openInfo(title, text){
    this.modalCtrl.create(InfoModalPage, {
      title: title,
      text: text
    }).present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/xp-report-workorder/xp-report-workorder.ts